import $ from 'jquery';

import React from 'react'
import ReactDOM from "react-dom";

require("../scss/index.scss");
import SearchField from "./SearchField";


$(()=>{

    $(".search-field").each((i, elem) => {

        const $elem = $(elem);
        const root = $elem.find(".search-field-root")[0];
        const autocomplete = $elem.data("autocomplete");

        ReactDOM.render(
            <SearchField
                autocomplete={autocomplete}
            />,
            root
        );

    });

});




// WEBPACK FOOTER //
// ./cms_plugins/search_field/js/index.js